import { render, staticRenderFns } from "./FormManageDepartment.vue?vue&type=template&id=3bdab5ca&"
import script from "./FormManageDepartment.vue?vue&type=script&lang=js&"
export * from "./FormManageDepartment.vue?vue&type=script&lang=js&"
import style0 from "./FormManageDepartment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports